<template>
<div class="survey-sensitivedetails">
    <template v-if="optionEnabled('passport')">
        <div class="survey-sensitivedetails__passport_country">
            <label for="passport_country" >{{ $_locale('passport_country') }}</label>
            <input v-model="passport_country" 
                type="text"
                maxlength="3" 
                id="passport_country" 
                name="passport_country" 
                autocomplete="off"
                @input="onValueChange">
        </div>
        <div class="survey-sensitivedetails__passport_family_name">
            <label for="passport_family_name">{{ $_locale('passport_family_name') }}</label>
            <input v-model="passport_family_name" 
                type="text"
                id="passport_family_name"    
                name="passport_family_name" 
                autocomplete="off"
                @input="onValueChange">
        </div>
        <div class="survey-sensitivedetails__passport_given_names">
            <label for="passport_given_names">{{ $_locale('passport_given_names') }}</label>
            <input v-model="passport_given_names" 
                type="text"
                id="passport_given_names"
                name="passport_given_names" 
                autocomplete="off"
                @input="onValueChange">
        </div>

        <div class="survey-sensitivedetails__passport_passport_no">
            <label for="passport_number" >{{ $_locale('passport_no') }}</label>
            <input v-model="passport_number" 
                type="text"
                id="passport_number"    
                name="passport_number" 
                autocomplete="off"
                @input="onValueChange">
        </div>
        <div class="survey-sensitivedetails__passport_passport_issued">
            <label for="passport_issued" >{{ $_locale('passport_issued') }}</label>
            <input 
                @change="handleDate" 
                type="date"
                id="passport_issued" 
                name="passport_issued" 
                autocomplete="off">
        </div>
        <div class="survey-sensitivedetails__passport_passport_expiry">
            <label for="passport_expiry">{{ $_locale('passport_expiry') }}</label>
            <input 
                @change="handleDate" 
                type="date"
                id="passport_expiry"
                name="passport_expiry" 
                autocomplete="off">
        </div>

        <div class="survey-sensitivedetails__passport_issuing_authority">
            <label for="passport_issuing_authority">{{ $_locale('passport_issuing_authority') }}</label>
            <input v-model="passport_issuing_authority" 
                type="text"
                id="passport_issuing_authority"
                name="passport_issuing_authority" 
                autocomplete="off"
                @input="onValueChange">
        </div>
        <div class="survey-sensitivedetails__passport_gender">
            <label for="passport_gender">{{ $_locale('passport_gender') }}</label>
            <select v-model="passport_gender" 
                @change="onValueChange"
                id="passport_gender"
                name="passport_gender">
                <option value="">{{ $_locale('choose') }}</option>
                <option value="F">{{ $_locale('female') }}</option>
                <option value="M">{{ $_locale('male') }}</option>
                <option value="X">{{ $_locale('other') }}</option>
            </select>
        </div>
    </template>

    <template v-if="optionEnabled('passport_photo')">
        <div class="passportphoto_master" ref="passportPhoto">
            <label for="passport_photo">{{ $_locale('passport_photo') }}</label>
            <div class="dropzone">
                <p v-if="passportPhotoLoaded">
                    {{ $_locale('survey.sensitiveDetails_dropzoneFileLoaded') }}
                </p>
                <p v-if="!passportPhotoLoaded">
                    {{ $_locale('survey.sensitiveDetails_dropzoneDescription') }}
                </p>
                <img v-if="passportPhotoLoaded" :src="passport_photo" />
                <input type="file" 
                    accept="image/png,image/jpeg" 
                    id="passport_photo"
                    name="passport_photo" 
                    style="display:none" />
            </div>
        </div>
    </template>

    <template v-if="optionEnabled('special_diet_or_allergies')">
        <div class="survey-sensitivedetails__special_diet_or_allergies">
            <label for="special_diet_or_allergies">{{ $_locale('special_diet_or_allergies') }}</label>
            <input type="text" 
                v-model="special_diet_or_allergies" 
                id="special_diet_or_allergies"
                name="special_diet_or_allergies" 
                maxlength="500" 
                autocomplete="off"
                @input="onValueChange" />
        </div>
    </template>
</div>
</template>

<script>
function isAllowedType(file) {
    const name = file.name.toLowerCase();
    const ext = name.split('.').pop();

    if (['heic', 'heif'].includes(ext)) {
        return false;
    }

    return ['image/png', 'image/jpeg'].includes(file.type)
}

function readFileAsDataURL(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    })
}

async function handleFile(file) {
    if (!isAllowedType(file)) {
        return {
            success: false,
            error: 'survey.sensitiveDetails_fileTypeError'
        }
    }
    
    try {
        const dataURL = await readFileAsDataURL(file)

        return {
            success: true,
            content: dataURL,
        }
    } catch {
        return {
            success: false,
            error: 'survey.sensitiveDetails_fileReadError'
        }
    }
}

export default {
    emits: ['valueChange'],
    props: {
        element: {
            type: Object,
            required: true,
        },
        initialValue: {
            required: false,
        },
    },
    data: () => ({
        passport_country: '',
        passport_family_name: '',
        passport_given_names: '',
        passport_number: '',
        passport_issued: '',
        passport_expiry: '',
        passport_issuing_authority: '',
        passport_gender: '',
        passport_photo: '',
        special_diet_or_allergies: '',
        passportPhotoLoaded: false,
    }),
    computed: {
        optionEnabled() {
            const { options } = this.element

            return (name) => options.includes(name)
        },
    },
    methods: {
        handleEmit() {
            const { options, type } = this.element
            const value = {
                type: 'sensitiveDetails',
            }

            options.forEach(option => {
                if (option === 'passport') {
                    value['passport_country'] = this.passport_country
                    value['passport_given_names'] = this.passport_given_names
                    value['passport_family_name'] = this.passport_family_name
                    value['passport_number'] = this.passport_number
                    value['passport_issued'] = this.passport_issued
                    value['passport_expiry'] = this.passport_expiry
                    value['passport_issuing_authority'] = this.passport_issuing_authority
                    value['passport_gender'] = this.passport_gender
                } else {
                    value[option] = this[option]
                }
            })

            this.$emit('valueChange', { questionId: 'sensitiveDetails', value, questionType: type })
        },
        // handle value and emit valueChange
        onValueChange() {
            this.$nextTick(() => this.handleEmit())
        },
        handleDate(evt) {
            const { value, name } = evt.target
            const date = new Date(value)

            if (!isNaN(date)) {
                this[name] = value
            } else {
                this[name] = ''
            }
            
            this.$nextTick(() => this.handleEmit())
        },
        initDropzone() {
            const { passportPhoto } = this.$refs
            const dropzone = passportPhoto.querySelector('.dropzone')
            const fileInput = passportPhoto.querySelector('[name="passport_photo"]')
            const onFileChange = async (file) => {
                const result = await handleFile(file)

                if (result.success) {
                    this.passportPhotoLoaded = true
                    this['passport_photo'] = result.content
                } else {
                    this.$_showErrorDialog(this.$_locale(result.error))
                }
            }
            
            dropzone.addEventListener('dragenter', (e) => {
                e.preventDefault()
                dropzone.classList.add('dragover')
            })
            
            dropzone.addEventListener('dragleave', (e) => {
                e.preventDefault()
                dropzone.classList.remove('dragover')
            })
            
            dropzone.addEventListener('dragover', (e) => {
                e.preventDefault()
            })
            
            dropzone.addEventListener('drop', (e) => {
                e.preventDefault()
                dropzone.classList.remove('dragover')

                const file = e.dataTransfer.files[0]

                if (file) {
                    onFileChange(file)
                }  
            })

            dropzone.addEventListener('click', () => fileInput.click())

            fileInput.addEventListener('change', e => {
                const file = e.target.files[0]

                if (file) {
                    onFileChange(file)
                }
            })
        },
    },
    mounted() {
        //const settings = window.wnSurveySettings || {}
        
        if (this.initialValue) {
            Object.keys(this.initialValue).forEach(key => {
                const value = this.initialValue[key]
                
                this[key] = value
                console.log('sensitiveDetails', this[key], value)
            })
        }

        this.onValueChange()

        this.$nextTick(() => {
            if (this.optionEnabled('passport_photo')) {
                this.initDropzone()
            }
        })
    }
}
</script>